import React, {
    useContext, useCallback, useEffect, useState
} from 'react';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from 'gw-portals-viewmodel-react';
import { useValidation } from 'gw-portals-validation-react';

import metadata from './CanceledPolicyComponent.metadata.json5';
import messages from './CanceledPolicyComponent.messages';
import styles from './CanceledPolicyComponent.module.scss';

function CanceledPolicyComponent(props) {
    const translator = useContext(TranslatorContext);
    const { submissionVM, updateWizardData } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const { isComponentValid, initialValidation, onValidate, registerComponentValidation } = useValidation('PackageDetailsPage');

    useEffect(() => {
        if (submissionVM.baseData.priorCancelledRecords && _.isEmpty(submissionVM.baseData.priorCancelledRecords.value)) {
            addCanceledPolicy()
        }
    }, [registerComponentValidation]);

    const deleteCancelledPolicy = useCallback(
        (evt) => {
            const index = evt.index;
            submissionVM.baseData.priorCancelledRecords.value.splice(index,1);
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const addCanceledPolicy = () => {
        const priorCancelledRecords = _.get(submissionVM,'baseData.priorCancelledRecords');
        priorCancelledRecords.value = priorCancelledRecords.value || [];
        const { _xCenter, _dtoName } = priorCancelledRecords;
        const additionalVM = viewModelService.create({}, _xCenter, _dtoName);
        _.set(additionalVM, 'isValidationRequired',true);

        priorCancelledRecords.pushElement(additionalVM);
        updateWizardData(submissionVM);
    };

    const overrideTitleProps = useCallback(() => {
        if(submissionVM.baseData.priorCancelledRecords.value) {
        const overrideProps = submissionVM.baseData.priorCancelledRecords.value.map((value, index) => {
            return {
                [`cancellationDetailHeaderCount${index}`]: {
                   // visible: index > 0,
                    content: translator(messages.cancelledPolicy) + (index + 1)
                },
                [`baDeleteCancelledPolicy${index}`]:{
                    disabled: submissionVM.baseData.priorCancelledRecords.value.length == 1
                }
            };
        });

        return Object.assign({}, ...overrideProps);
    } else {return null}
    }, [submissionVM]);

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showRequired: true
        },
        addPolicy: {
            onClick: addCanceledPolicy
        },

        ...overrideTitleProps()
    };
    const resolvers = {
        resolveCallbackMap: {
            deleteCancelledPolicy: deleteCancelledPolicy,
            addCanceledPolicy:addCanceledPolicy
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={submissionVM}
            overrideProps={overrideProps}
            onModelChange={updateWizardData}
            onValidationChange={onValidate}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={styles}
        />

    );
}

CanceledPolicyComponent.propTypes = wizardProps;
export default CanceledPolicyComponent;
